import {BaseService} from "@/core/services/BaseService";

class RecoveryService extends BaseService<any> {
  endpoint = "/recovery";
}
export default new RecoveryService();